import axios from "axios";

export default async function callBackFormSubmit(data) {
  try {
    const response = await axios({
      method: "post",
      url: `https://leads.pointofconnect.com/api/leads/webapi/5b4a1d41-806c-494a-a474-7f73a6c203bb`,
      data: data,
    });
    const res = await response.data;
    return res;
  } catch (error) {
    throw new Error(error?.message);
  }
}
